// this page created by akash-ak

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ vendor, onInputChange, tabOneFormData, errors }) => {
  const select_transaction_type = [
    { name: 'Purchase Order' },
    { name: 'Sale Return' },
  ];

  return (
    <>
      <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
        <div className="col-12">
          <p className="boxLabel m-0">General Details</p>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <Input
                id="naming_series"
                label="No."
                style={{ height: "30px" }}
                readOnly


                
                value={tabOneFormData.naming_series}
                onChange={(e) => onInputChange('naming_series', e.target.value)}
              />
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <Input
                id="builty_no"
                label="Builty No."
                // style={{ height: "30px" }}
                value={tabOneFormData.builty_no}
                onChange={(e) => onInputChange('builty_no', e.target.value)}
                style={{
                  height: "30px",
                  whiteSpace: 'pre-wrap',
                  border: errors?.builty_no ? '1px solid red' : ''
                }}
              />


            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <Input
                id="asn_no"
                label="ASN no."
                style={{
                  height: "30px",
                  whiteSpace: 'pre-wrap',
                  border: errors?.asn_no ? '1px solid red' : ''
                }}
                value={tabOneFormData.asn_no}
                onChange={(e) => onInputChange('asn_no', e.target.value)}

              />

            </div>
          </div>
        </div>

        <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <SelectSearch
                list={select_transaction_type}
                label="Select Transaction Type"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={tabOneFormData.select_transaction_type}
                onChange={(value) => onInputChange('select_transaction_type', value)}
                placeholder=""

                error={errors?.select_transaction_type}
              />
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <div className="mb-3">
              <SelectSearch
                list={vendor.vendor_list}
                label="Select Supplier"
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item.name}
                value={tabOneFormData.vendor_name}
                onChange={(value) => onInputChange('vendor_name', value)}
                className={errors?.vendor_name ? 'error-border' : ''}
                error={errors?.vendor_name}

              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;